import * as React from 'react';
import Stack from '@mui/material/Stack';
import { Button as BaseButton, buttonClasses } from '@mui/base/Button';
import { styled } from '@mui/system';

const blue = {
  500: '#007FFF',
  600: '#0072E5',
  700: '#0059B2',
};

const CustomButton = styled(BaseButton)(({theme}) => `
font-family: IBM Plex Sans, sans-serif;
font-weight: bold;
font-size: 0.875rem;
background-color: ${theme.palette.primary.main};
padding: 12px 24px;
border-radius: 8px;
color: white;
transition: all 150ms ease;
cursor: pointer;
border: none;

&:hover {
  background-color: ${blue[600]};
}

&.${buttonClasses.active} {
  background-color: ${blue[700]};
}

&.${buttonClasses.focusVisible} {
  box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 5px rgba(0, 127, 255, 0.5);
  outline: none;
}

&.${buttonClasses.disabled} {
  opacity: 0.5;
  cursor: not-allowed;
}
`);

export default CustomButton;